// extracted by mini-css-extract-plugin
module.exports = {"pageNavigationMenu":"PageNavigationMenu_pageNavigationMenu__pT4F1","heading":"PageNavigationMenu_heading__SI0nG","list":"PageNavigationMenu_list__oJ9FG"};